import { Theme } from '@mui/material/styles'
import { sliderClasses } from '@mui/material/Slider'

// ----------------------------------------------------------------------

export function slider(theme: Theme) {
  return {
    MuiSlider: {
      styleOverrides: {
        root: {
          [`&.${sliderClasses.disabled}`]: {
            color: theme.vars.palette.action.disabled,
          },
        },
        rail: {
          opacity: 0.32,
        },
        markLabel: {
          fontSize: 13,
          color: theme.vars.palette.text.disabled,
        },
        valueLabel: {
          borderRadius: 8,
          backgroundColor: theme.vars.palette.grey[800],
          '[data-mui-color-scheme="dark"] &': {
            backgroundColor: theme.vars.palette.grey[700],
          },
        },
      },
    },
  }
}
